import "./Solutions.module.css";
import MainNavigationHeader from "@/reusable_sections/Header";
import HeroIntroduction from "./sections/HeroIntroduction";
import SiemensParts from "./sections/SiemensParts";
import IndustriesServed from "./sections/IndustriesServed";
import SpecializedServices from "./sections/SpecializedServices";
import CallToAction from "./sections/CallToAction";
import SiemensSolutions from "./sections/SiemensSolutions";
import CorporateInformationFooter from "@/reusable_sections/Footer";
export default function SolutionsPage() {
  return <div>
      <MainNavigationHeader />
      <HeroIntroduction />
      <SiemensParts />
      <IndustriesServed />
      <SpecializedServices />
      <SiemensSolutions />
      <CallToAction />
      <CorporateInformationFooter />
    </div>;
}